class MobileNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.nav = this.querySelector('#header__mobile-nav');
    this.categorySubMenu = this.querySelector('#header__mobile-nav__category-submenu');
    this._setMobileNavPositionAndHeight()

    // toggle mobile nav with burger
    this.handleMobileNavToggle = this.handleMobileNavToggle.bind(this);
    this.burgerButton = this.querySelector('#header__mobile-nav__burger-button');
    this.burgerButton.addEventListener('click', this.handleMobileNavToggle);

    // toggle category subnav
    this.handleCategorySubMenuToggle = this.handleCategorySubMenuToggle.bind(this);
    this.categorySubMenuButton = this.querySelector('#header__mobile-nav__category-submenu__button');
    this.categorySubMenuCloseButton = this.querySelector('#header__mobile-nav__category-submenu__close-button');
    this.categorySubMenuButton.addEventListener('click', this.handleCategorySubMenuToggle);
    this.categorySubMenuCloseButton.addEventListener('click', this.handleCategorySubMenuToggle);

    // toggle each subnav with + or -
    this.handleMobileSubnavToggle = this.handleMobileSubnavToggle.bind(this);
    this.subnavButtons = this.querySelectorAll('[data-subnav-button]');
    this.subnavButtons.forEach(button => {
      button.addEventListener('click', this.handleMobileSubnavToggle);
    })
  }
  
  disconnectedCallback() {
    this.burgerButton.removeEventListener('click', this.handleMobileNavToggle);
    this.categorySubMenuButton.removeEventListener('click', this.handleCategorySubMenuToggle);
    this.categorySubMenuCloseButton.removeEventListener('click', this.handleCategorySubMenuToggle);
    this.subnavButtons.forEach(button => {
      button.removeEventListener('click', this.handleMobileSubnavToggle);
    })
  }

  _setMobileNavPositionAndHeight() {
    // set the position and height of the mobile-nav based on the header height
    // so that it will be right underneath the header instead of overlay ontop
    const headerHeight = document.querySelector('#header__container').clientHeight;
    const screenHeight = window.innerHeight;
    this.nav.style.top = headerHeight;
    this.nav.style.height = screenHeight - headerHeight  ;
    this.categorySubMenu.style.top = headerHeight;
    this.categorySubMenu.style.height = screenHeight - headerHeight  ;
  }

  handleMobileNavToggle() {
    const navVisibility = this.nav.dataset.visibility;
    if (navVisibility === "hidden") {
      this.nav.dataset.visibility = "show";
      document.body.style.overflow = "hidden";
    } else {
      this.nav.dataset.visibility = "hidden";
      this.categorySubMenu.dataset.visibility = "hidden"
      document.body.style.overflow = "auto";
    }
  }

  handleMobileSubnavToggle(e) {
    const subnav = e.target.closest('li');
    if (subnav.dataset.subnav === "close") {
      subnav.dataset.subnav = "open";
    } else {
      subnav.dataset.subnav = "close";
    }
  }

  handleCategorySubMenuToggle() {
    console.log('Clicked')
    const subMenuVisibility = this.categorySubMenu.dataset.visibility;
    if (subMenuVisibility === "hidden") {
      this.categorySubMenu.dataset.visibility = "show";
    } else {
      this.categorySubMenu.dataset.visibility = "hidden";
    }
  }
}

customElements.define('mobile-nav', MobileNav);
